import { config } from "./../config";
import { commonFunctions } from "../_utilities";

export const paymentServices = {
  getPaymentIntent,
  updatePaymentStatus,
};

function getPaymentIntent(data) {
  const extraHeaders = {
    "Content-Type": "application/json",
  };
  const requestOptions = commonFunctions.getRequestOptions(
    "post",
    extraHeaders,
    JSON.stringify(data),
    true
  );
  // A rejected order comes back as 400 with the same JSON shape, so callers read
  // res.status and res.errors rather than relying on fetch throwing.
  return fetch(`${config.localApiUrl}/api/order`, requestOptions).then((response) =>
    response.json().then((body) => ({
      ...body,
      status: body?.status ?? response.status,
    }))
  );
}

function updatePaymentStatus(data) {
  const extraHeaders = {
    "Content-Type": "application/json",
  };
  const requestOptions = commonFunctions.getRequestOptions(
    "put",
    extraHeaders,
    JSON.stringify(data),
    true
  );
  return fetch(
    `${config.localApiUrl}/api/order/payment/status`,
    requestOptions
  ).then((response) => response.json());
}
